import gql from "graphql-tag";

export const registerNavigation = gql`
  mutation registerNavigation($targetScreen: String!, $sourceScreen: String!, $targetPatientId: Int!) {
    registerNavigation(targetScreen : $targetScreen, sourceScreen : $sourceScreen, targetPatientId: $targetPatientId)
  }
`;